export default __webpack_public_path__ + "static/joko-app-screenshot-home-2-en@2x-f3c8c0491358097d0782ad024ea0aafb.webp";